import { useFetchAPI } from '~/composables/api/useFetchAPI'
import { API_LOGIN, API_LOGOUT } from '~/constants/routes/api/auth/routes.api.constants'
import { INDEX } from '~/constants/routes/routes.constants'

export const useAuth = () => useNuxtApp().$auth

export const useLogin = async (data: { username: string, password: string }) => {
  const config = useRuntimeConfig().public

  await useFetch(API_LOGIN.path, {
    baseURL: config.api_base_url,
    method: API_LOGIN.method,
    body: data,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': 'true',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'include',
    onResponse ({ response }) {
      if (response.ok) {
        useAuth().updateSession.value?.().then(() => {
          navigateTo(INDEX.path)
        })
      }
    },
    onResponseError () {
      toastError({ title: 'Utilisateur introuvable' })
    }
  })
}

export const useLogout = async () => {
  await useFetchAPI(API_LOGOUT.path, {
    method: API_LOGOUT.method
  }).then(async () => {
    await useAuth().updateSession.value?.()
  })
}
